import {Axios} from "axios";

const useAxios = () => {
    return new Axios({
        baseURL:"https://adroitsystems.io",
        headers:{"Accept":"*/*","Content-Type":"application/json","x-http2-scheme": "https"},
    })
}

export default useAxios;